module.exports = __webpack_public_path__ + "img/driver_unavailable.023c0375.svg";